import {Space} from "antd";
import {useFormContext} from "react-hook-form";
import {IS_PWYW_ENABLED} from "../../../../services/config";
import {PricingModelCardsFormField} from "../../general/pricing/pricing-model-cards";
import {PwywCurrenciesFormField} from "../../general/pricing/pwyw-currencies";
import {SessionCurrenciesFormField} from "../../session-bundle/session/pricing/currencies";
import {SessionPricingFormFieldsType} from "../../session-bundle/session/pricing/types";

/**
 * The live event's Pricing section.
 *
 * A live event has no Add-ons, so every choice of Pricing Model applies straight away and
 * the shared cards do the whole job. The two props are what this offering type costs: it
 * spells the Pricing Model `callPriceType`, and it keeps its base currency in
 * `callPriceCurrency`/`callPrice` rather than in `currencies[0]`.
 */
export function LiveEventPricingFormFields() {
  const {watch} = useFormContext<SessionPricingFormFieldsType>();
  const isPayWhatYouWant = IS_PWYW_ENABLED && watch("callPriceType") === "pwyw";

  return (
    <Space size={16} direction="vertical" style={{display: "flex"}}>
      <PricingModelCardsFormField priceTypeField="callPriceType" baseCurrencyInScalars />
      {isPayWhatYouWant ? (
        <PwywCurrenciesFormField />
      ) : (
        <SessionCurrenciesFormField
          id="liveEventPrice"
          label="Other price"
          placeholder="100"
        />
      )}
    </Space>
  );
}
